import { MutableRefObject } from "react";

export type SidebarMenuKeyType = keyof typeof MENU_ITEMS_TYPE;

export type SidebarMenuItemKeyType =
	| keyof typeof MENU_ITEMS_TYPE.organization
	| keyof typeof MENU_ITEMS_TYPE.account
	| keyof typeof MENU_ITEMS_TYPE.application;

export type SidebarMenuItemValueType = {
	path: string;
	title: string;
	selected?: string;
};

export type SidebarMenuItemType = Record<
	SidebarMenuItemKeyType,
	SidebarMenuItemValueType
>;

export type SidebarMenuType = Record<SidebarMenuKeyType, SidebarMenuItemType>;

export const MENU_ITEMS = [
	{
		organization: {
			general: {
				path: "/organization/general",
				title: "일반",
			},
			applications: {
				path: "/organization/applications",
				title: "어플리케이션",
			},
			members: {
				path: "/organization/members",
				title: "멤버관리",
			},
			billing: {
				path: "/organization/billing/applicationList",
				title: "결제/청구",
				selected: "/organization/billing",
			},
			contact: {
				path: "/organization/contact",
				title: "문의하기",
			},
			contract: {
				path: "/organization/contract",
				title: "표준계약서 확인",
			},
		},
		application: {
			dashboard: {
				path: "/application/:id/dashboard",
				title: "대시보드",
			},
			settings: {
				path: "/application/:id/setting",
				title: "환경설정",
			},
		},
		account: {
			profile: {
				path: "/account/profile",
				title: "프로필",
			},
			security: {
				path: "/account/security",
				title: "보안설정",
			},
		},
	},
	{
		organization: {
			general: {
				path: "/organization/general",
				title: "General",
			},
			applications: {
				path: "/organization/applications",
				title: "Application",
			},
			members: {
				path: "/organization/members",
				title: "Member Management",
			},
			billing: {
				path: "/organization/billing/applicationList",
				title: "Payment / Billing",
				selected: "/organization/billing",
			},
			contact: {
				path: "/organization/contact",
				title: "Contact Us",
			},
			contract: {
				path: "/organization/contract",
				title: "Standard Confirmation Document",
			},
		},
		application: {
			dashboard: {
				path: "/application/:id/dashboard",
				title: "Dashboard",
			},
			settings: {
				path: "/application/:id/setting",
				title: "Setting",
			},
		},
		account: {
			profile: {
				path: "/account/profile",
				title: "Profile",
			},
			security: {
				path: "/account/security",
				title: "Security Settings",
			},
		},
	},
] as const;

/* export const MENU_ITEMS = {
	organization: {
		general: {
			path: "/organization/general",
			title: "일반",
		},
		applications: {
			path: "/organization/applications",
			title: "어플리케이션",
		},
		members: {
			path: "/organization/members",
			title: "멤버관리",
		},
		billing: {
			path: "/organization/billing/applicationList",
			title: "결제/청구",
			selected: "/organization/billing",
		},
		contact: {
			path: "/organization/contact",
			title: "문의하기",
		},
		contract: {
			path: "/organization/contract",
			title: "표준계약서 확인",
		},
	},
	application: {
		dashboard: {
			path: "/application/:id/dashboard",
			title: "대시보드",
		},
		settings: {
			path: "/application/:id/setting",
			title: "환경설정",
		},
	},
	account: {
		profile: {
			path: "/account/profile",
			title: "프로필",
		},
		security: {
			path: "/account/security",
			title: "보안설정",
		},
	},
} as const; */

export const MENU_ITEMS_TYPE = {
	organization: {
		general: {
			path: "",
			title: "",
		},
		applications: {
			path: "",
			title: "",
		},
		members: {
			path: "",
			title: "",
		},
		billing: {
			path: "",
			title: "",
			selected: "",
		},
		contact: {
			path: "",
			title: "",
		},
		contract: {
			path: "",
			title: "",
		},
	},
	application: {
		dashboard: {
			path: "",
			title: "",
		},
		settings: {
			path: "",
			title: "",
		},
	},
	account: {
		profile: {
			path: "",
			title: "",
		},
		security: {
			path: "",
			title: "",
		},
	},
} as const;

export type MENU_ITEM_TYPE = MutableRefObject<typeof MENU_ITEMS_TYPE>;
